export default function CoinflipIcon() {
  return (
    <svg xmlns='http://www.w3.org/2000/svg' width='55' height='55' viewBox='0 0 200 200'>
      <circle cx='100' cy='100' r='90' fill='#504AED' />
      <circle cx='100' cy='100' r='60' fill='#F9CC3D' />
    </svg>
  )
}
